<app-tag
    *ngFor="let tag of tags"
    tagText="{{tag.name}}"
    type="{{tag.type}}"
>
</app-tag>
<div id="moreTag" (click)="openTagsDialog($event)" class="more-tag" [ngClass]="{'hide' : !showMoreTag}">More</div>            
